'use client';

import type { ProcessedTechnology } from '@/lib/api/technologies';
import { styled } from '@linaria/react';
import { AnimatePresence } from 'motion/react';
import * as motion from "motion/react-client";
import { useState, useTransition } from 'react';
import { TechnologyPill, TechnologyPillRaw } from './TechnologyPill';
import { useEffectEvent } from '@floating-ui/react/utils';
import "./TechnologiesSectionLowFamiliarity.linaria.module.css!=!./TechnologiesSectionLowFamiliarity?./TechnologiesSectionLowFamiliarity.linaria.module.css?css=H4sIAAAAAAAAA9VR246bMBB936+wVCElEkSGLput/ZK3/kB/wOABZmNsajsNKeLfKy5JSHeTSlVfygMan3PmeDxn42N5ErRsu0zk+9Kag5ZMGw08M1aCnepGSIm6ZJTXwpaoGeWmETn6E6P8iNJXjPIf6DBDNYAVSgma908bn8BzUb91hdE+cvgTWLxJLNR8BI6AZeVZZpScbRLatLya4LGW6BolTiw6QrZHH2XmPVYoWIC1G4GlcBSc1UJhqSP0UDuWg/Zg+cJ8oi/EbHaL/sGhEfn+ncENOIvfDs5jcYpyoz1of6bvwIuAbJmJVZKmIbn+6CZez6FFVkg8OJbSgPe7GiQK4nILoInQkqxq0UbTuskXGjfturvkNMHxyzWFsV7EN4TXD8miVN9f990yyC2lPDfKWPapGL/l0Ao1CBuVw3Cg/Sr5nEooQ1I5tYq3aUjSlyAkaRqsJyx5piHZ0iAkr/SM/Tvd+hrZZcTphSmlAYkpDfh95oPeXGHDPLT+MfmwYzhEBSoVTVv0VmjXCAv6qhEaa+HRaOZNWSr4Bq3/Ou80mkMhqSPTugnqAjV64H/b1+/ON+/hVFhRgyP3HToadB+8vzEOx7tpQNLbzf5O9cOCH3oMgrsuF7Lvd//bwE+/AELWaWWOBQAA"
const _exp = /*#__PURE__*/() => motion.button;
const ToggleButton = /*#__PURE__*/styled(_exp())({
  name: "ToggleButton",
  class: "t1dya0gx",
  propsAsIs: true
});
const ToggleIcon = /*#__PURE__*/styled('span')({
  name: "ToggleIcon",
  class: "t2e4fmj",
  propsAsIs: false
});
const ToggleText = /*#__PURE__*/styled('span')({
  name: "ToggleText",
  class: "tidlq8k",
  propsAsIs: false
});
export function LowFamiliarityTechsDisplay({
  lowFamiliarityTechs
}: {
  readonly lowFamiliarityTechs: ProcessedTechnology[];
}) {
  const [showAll, setShowAll] = useState(false);
  const doShowMoreButton = lowFamiliarityTechs.length > 5;
  return <AnimatePresence mode="popLayout">
		{!doShowMoreButton || showAll ? lowFamiliarityTechs.map((tech, i) => <motion.div key={tech.id} layoutId={tech.id} layout initial={{
      opacity: 0,
      height: 1,
      scaleY: 0.7,
      y: 30
    }} animate={{
      opacity: 1,
      height: 'auto',
      scaleY: 1,
      y: 0,
      transition: {
        duration: 0.3,
        delay: 0.08 + i * 0.1,
        y: {
          type: 'spring',
          stiffness: 32,
          damping: 8,
          restDelta: 0.3
        }
      }
    }} exit={{
      opacity: 0,
      y: 60,
      height: 0,
      transition: {
        duration: 0.1,
        delay: (lowFamiliarityTechs.length - i) * 0.025
      }
    }}>
				<TechnologyPill technology={tech} extraProps={{
        style: {
          // @ts-ignore -- this is a custom CSS property for animation staggering
          '--index': i
        }
      }} />
			</motion.div>) : null}

		{doShowMoreButton ? <LowFamiliarityTechsDisplayMoreToggleButton showAll={showAll} setShowAll={setShowAll} howManyMore={lowFamiliarityTechs.length} /> : null}
	</AnimatePresence>;
}
function LowFamiliarityTechsDisplayMoreToggleButton({
  showAll,
  setShowAll,
  howManyMore
}: {
  readonly showAll: boolean;
  readonly setShowAll: React.Dispatch<React.SetStateAction<boolean>>;
  readonly howManyMore: number;
}) {
  const [isTransitioning, startTransition] = useTransition();
  const handleToggleShowAll = useEffectEvent(() => {
    startTransition(() => {
      setShowAll(prev => !prev);
    });
  });
  return <ToggleButton type="button" onClick={handleToggleShowAll} aria-expanded={showAll} initial={{
    opacity: 0,
    width: 0,
    visibility: 'hidden'
  }} animate={{
    marginLeft: showAll ? 0 : 20,
    opacity: 1,
    width: 'auto',
    visibility: 'visible'
  }} transition={{
    duration: 3,
    bounce: 0.8,
    damping: 5.1,
    type: 'spring'
  }}>
		<TechnologyPillRaw iconNode={<ToggleIcon>{showAll ? '−' : '+'}</ToggleIcon>} nameNode={<ToggleText>{showAll ? 'Show Fewer' : <>+{howManyMore} Less Familiar Techs</>}</ToggleText>} backgroundColor={isTransitioning ? "#111" : "#000"} bumpIntensity={isTransitioning ? 30 : 4} />
	</ToggleButton>;
}